import {Callback, Prose} from '@raison/types';
import {RsnPane, RsnSkeleton, styles} from '@raison/ui-kit';
import React from 'react';
import {DashboardDualDetailLine} from './DashboardCategoryShortLine';

type IconProps =
    | {
          icon: string | null;
          fallbackIcon: string;
      }
    | {
          icon: string;
          fallbackIcon?: undefined;
      };

export function DashboardAssetItem(
    props: IconProps & {
        onClick: Callback;
        onPointerDown?: Callback;
        title: Prose;
        detail: Prose | [Prose, Prose];
        amount: Prose;
    }
) {
    return (
        <RsnPane
            as='button'
            type='button'
            onClick={props.onClick}
            onPointerDown={props.onPointerDown}
            className={cls.pane}
        >
            {props.icon != null ? (
                <RsnPane.Icon src={props.icon} />
            ) : (
                <RsnPane.IconFrame>
                    <RsnPane.Icon src={props.fallbackIcon!} />
                </RsnPane.IconFrame>
            )}
            <RsnPane.TextBlock>
                <RsnPane.PrimaryText truncate>{props.title}</RsnPane.PrimaryText>
                <RsnPane.SecondaryText>{<DashboardDualDetailLine detail={props.detail} />}</RsnPane.SecondaryText>
            </RsnPane.TextBlock>
            <RsnPane.MetaBlock>
                <RsnPane.PrimaryText>{props.amount}</RsnPane.PrimaryText>
            </RsnPane.MetaBlock>
        </RsnPane>
    );
}

DashboardAssetItem.Skeleton = function DashboardAssetItemSkeleton() {
    return (
        <RsnPane as='div' className={cls.pane}>
            <RsnSkeleton circle className='size-9' />
            <RsnPane.TextBlock>
                <RsnPane.PrimaryText meta={<RsnSkeleton width={50} />}>
                    <RsnSkeleton width={80} />
                </RsnPane.PrimaryText>
                <RsnPane.SecondaryText>
                    <RsnSkeleton width={40} />
                </RsnPane.SecondaryText>
            </RsnPane.TextBlock>
        </RsnPane>
    );
};

const cls = styles({
    pane: 'border-b border-solid border-neutral-30 py-4 last-of-type:border-b-0',
});
